import { memo, useEffect, useState, useLayoutEffect } from "react";
import Box from "../../Components/Box";
import FlexBox from "../../Components/FlexBox";
import Image from '../../Components/Image';
import { H3, H5 } from "../../Components/Typography";
import Accordion from '../../Components/accordion/Accordion';
import AccordionHeader from '../../Components/accordion/AccordionHeader';
import { AccordionWrapper } from '../../Components/accordion/AccordionStyle';
import AppLayout from "../../Components/layout/AppLayout";
import Navbar from "../../Components/navbar/Navbar";
import ProductIntro from '../../Components/products/ProductIntro';
import useWindowSize from '../../hooks/useWindowSize';
import StyledProductPage from './ProductPageStyle';
import url from './background.jpeg';
import { useAppContext } from "../../contexts/app/AppContext";
import { AccordionDetails } from "@mui/material";
import { router } from '@inertiajs/react'
import RelatedProductsCarousel from "./RelatedProductsCarousel";
import { useTranslation } from "react-i18next";

const ProductPage = memo(function ProductPage(props) {

  const screenWidth = useWindowSize()
  const { setFooterVisible } = useAppContext()
  const { t } = useTranslation()

  useEffect(() => {
    setFooterVisible(true)
    history.scrollRestoration = "manual";

  }, [])

  return (

    <AppLayout showBgImage={true} ulrBg={url} navbar={<Navbar />} seo={props.seo}>
      {/* <Box className='background-product-page'></Box> */}
      <StyledProductPage my="8.5rem" mb='3rem'>

        <ProductIntro auth={props.auth} product={props.product.data} imgUrl={props.product.data['images']} title={props.product.data['name']} price={props.product.data['price']}
          id={props.product.data['id']} sku={props.product.data['sku']} description={props.product.data['description']} breadcrumbs={props.breadcrumbs}
          initialPrice={props.product.data['initialPrice']} discount_percent={props.product.data['off']} tax_price={props.product.data['tax_price']}
          tax_percent={props.product.data['tax_percent']}
        />

        <FlexBox className='accordion-section'>
          {screenWidth <= 900 && props.product.data['description'] && (
            <AccordionWrapper className="accordion-wrapper">
              <Accordion expanded={false}>
                <AccordionHeader
                  px="0px"
                  py="6px"
                  color="text.muted"
                  className='accordion-header'
                >
                  <H3 fontWeight='bold' className="cursor-pointer" ml="9px">
                    {t("product.details")}
                  </H3>
                </AccordionHeader>
                <Box>
                  <H5>
                    <Box dangerouslySetInnerHTML={{ __html: props.product.data.description }}></Box>
                  </H5></Box>
              </Accordion>
            </AccordionWrapper>
          )}

          {screenWidth > 900 && props.product.data['description'] &&
            <AccordionWrapper className="accordion-wrapper">
              <Accordion expanded={true}>
                <AccordionHeader
                  px="0px"
                  py="6px"
                  color="text.muted"
                  className='accordion-header'
                >
                  <H3 fontWeight='bold' className="cursor-pointer" ml="9px">
                  {t("product.details")}
                  </H3>
                </AccordionHeader>
                <Box>
                  <H5>
                    <Box dangerouslySetInnerHTML={{ __html: props.product.data.description }}></Box>
                  </H5>
                </Box>
              </Accordion>
            </AccordionWrapper>}

          {screenWidth <= 900 && props.product.data['composition'] && (
            <AccordionWrapper className="accordion-wrapper">
              <Accordion expanded={false}>
                <AccordionHeader
                  px="0px"
                  py="6px"
                  color="text.muted"
                  className={`accordion-header `}

                >
                  <H3 fontWeight='bold' className="cursor-pointer" ml="9px">
                  {t("product.composition")}
                  </H3>
                </AccordionHeader>
                <Box>
                  <H5>
                    <Box dangerouslySetInnerHTML={{ __html: props.product.data.composition }}></Box>
                  </H5>
                </Box>
              </Accordion>
            </AccordionWrapper>
          )}

          {screenWidth > 900 && props.product.data['composition'] && (
            <AccordionWrapper className="accordion-wrapper">
              <Accordion expanded={true}>
                <AccordionHeader
                  px="0px"
                  py="6px"
                  color="text.muted"
                  className={`accordion-header `}

                >
                  <H3 fontWeight='bold' className="cursor-pointer" ml="9px">
                  {t("product.composition")}
                  </H3>
                </AccordionHeader>
                <Box><H5>
                  <Box dangerouslySetInnerHTML={{ __html: props.product.data.composition }}></Box>

                </H5></Box>
              </Accordion>
            </AccordionWrapper>
          )}

          {screenWidth <= 768 && props.product.data?.size_chart &&
            <AccordionWrapper className="accordion-wrapper">
              <Accordion expanded={screenWidth > 900}>
                <AccordionHeader
                  px="0px"
                  py="6px"
                  color="text.muted"
                  className={`accordion-header `}

                >
                  <H3 fontWeight='bold' className="cursor-pointer" ml="9px">
                  {t("product.sizeguide")}
                  </H3>
                </AccordionHeader>
                <AccordionDetails sx={{ height: 350 }}>
                  <Image mt={2} src={props.product.data.size_chart} />
                </AccordionDetails>
              </Accordion>
            </AccordionWrapper>
          }
        </FlexBox>

        
        <RelatedProductsCarousel screenWidth={screenWidth} items={props?.related_products?.data}/>

      </StyledProductPage>
    </AppLayout>
  );
})

export default ProductPage;
